import React from "react";

import { withLoadingSuspense } from "components";

export const lazyPage = <T extends React.ComponentType<any>>(promise: () => Promise<{ default: T }>) => {
  const Component = React.lazy(promise);
  return withLoadingSuspense(Component);
};
